import { Injectable } from '@angular/core';
import {Producto} from '../../../model/class/Producto';
import {CodigoProducto} from '../../../model/class/CodigoProducto';
import {Archivo} from '../../../model/class/Archivo';
import {ICertificacion} from '../../../model/interface/ICertificacion';

@Injectable()
export class PreviewProductService {

  producto: Producto;
  codigos: CodigoProducto[] = [];
  colores: any[] = [];
  categorias: any[] = [];
  productosRelacionados: Producto[] = [];
  productosComplementarios: Producto[] = [];
  productosAlternativos: Producto[] = [];
  certificaciones: ICertificacion[] = [];
  imagenesProducto: Archivo[] = [];
  archivosGaleria: Archivo[] = [];
  archivosDescargables: any[] = [];

  constructor() { }

  borrar() {
    this.producto = undefined;
    this.codigos = [];
    this.colores = [];
    this.categorias = [];
    this.productosRelacionados = [];
    this.productosComplementarios = [];
    this.productosAlternativos = [];
    this.certificaciones = [];
    this.imagenesProducto = [];
    this.archivosGaleria = [];
    this.archivosDescargables = [];
  }

}



// WEBPACK FOOTER //
// /app/src/app/services/preview-product/preview-product.service.ts